module.exports = __webpack_public_path__ + "static/media/48364925_2308776002530911_5757127824603348992_o-thumb.c0b8c68d.jpg";